import React from "react";
import { Link } from "react-router-dom";
const ErrorComponent = () => {
	return (
		<div className="error-container">
			<p>Not found</p>
			<p>Error</p>
			<Link to="/" className="button-red">
				Main Page
			</Link>
		</div>
	);
};

export default ErrorComponent;
